<template>
    <div>
        <section class="container" @click="showModal">
            <div class="facts">
                <h4 class="system-box">
                    <span class="system-text">
                        {{ this.originSystemName }}
                        <i class="mdi mdi-dots-vertical-circle-outline icon"
                        ></i>
                    </span>
                </h4>
                <div class="type detail duration">
                    <span>{{ this.duration }}</span>
                    <small>{{ this.durationLabel }}</small>
                </div>
                <div class="type detail" v-html="this.optionName"></div>
            </div>
            <div class="status">
                <div class="text" v-if="this.status === this.statusTypeEnum.FINISHED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.validTitle') }}</dt>
                        <dd>{{ this.validityStartDate }} - {{ this.validityEndDate }}</dd>
                    </dl>
                </div>
                <div class="text" v-if="this.status === this.statusTypeEnum.REVOKED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.vignette') }}</dt>
                        <dd>{{ this.$t('shopEuropamaut.revoked') }}</dd>
                    </dl>
                </div>
                <div class="text" v-if="this.status === this.statusTypeEnum.DELETED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.vignette') }}</dt>
                        <dd>{{ this.$t('shopEuropamaut.deleted') }}</dd>
                    </dl>
                </div>
                <div class="text" v-if="this.status === this.statusTypeEnum.FAILED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.setup') }}</dt>
                        <dd class="text-danger">{{ this.$t('shopEuropamaut.failed') }}</dd>
                    </dl>
                </div>
                <div class="text" v-if="this.status === this.statusTypeEnum.CREATED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.setup') }}</dt>
                        <dd>
                            {{ this.$t('shopEuropamaut.setupPlanned') }}:
                            <template v-if="!dispatchAt">{{ validityStartDate }}</template>
                            <template v-else>{{ dispatchAtDate }}</template>
                        </dd>
                    </dl>
                </div>
                <div class="text long-text" v-if="this.status === this.statusTypeEnum.SCHEDULED">
                    <dl class="mt-1">
                        <dt>{{ this.$t('shopEuropamaut.setupScheduledHeading') }}</dt>
                        <dd>
                            {{ this.$t('shopEuropamaut.setupScheduled') }}:
                            <template>{{ dispatchAtDate }}</template>
                        </dd>
                    </dl>
                </div>
                <div class="text statusIconText" v-if="this.status === this.statusTypeEnum.FINISHED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.vignette') }}</dt>
                        <dd class="text-success">{{ this.$t('shopEuropamaut.hasBeenSetup') }}</dd>
                    </dl>
                </div>
                <div class="text statusIconText" v-if="this.status !== this.statusTypeEnum.FINISHED">
                    <dl>
                        <dt>{{ this.$t('shopEuropamaut.vignette') }}</dt>
                        <dd class="text-danger" v-if="this.status !== this.statusTypeEnum.STAGED">{{ this.$t('shopEuropamaut.notSetup') }}</dd>
                        <dd class="in-setup" v-if="this.status === this.statusTypeEnum.STAGED">{{ this.$t('shopEuropamaut.inSetup') }}</dd>
                        <dd class="text-danger" v-if="this.status === this.statusTypeEnum.DELETED">{{ this.$t('shopEuropamaut.deleted') }}</dd>
                        <dd class="text-danger" v-if="this.status === this.statusTypeEnum.REVOKED">{{ this.$t('shopEuropamaut.revoked') }}</dd>
                    </dl>
                </div>
                <div class="statusIcon" v-if="this.status === this.statusTypeEnum.STAGED">
                    <loading-animation
                        preloader-container-id=""
                        status-container-id=""
                        :loading-text="this.$t('shopEuropamaut.inSetup')"
                        :horizontal-centered="true"
                        :visible="true"
                    ></loading-animation>
                </div>
                <div class="statusIcon" v-if="this.status === this.statusTypeEnum.FINISHED">
                    <i class="mdi mdi-check-circle-outline" />
                </div>
                <div class="statusIcon" v-if="this.status === this.statusTypeEnum.CREATED">
                    <i class="mdi mdi-calendar-clock" />
                </div>
                <div class="statusIcon" v-if="this.status === this.statusTypeEnum.REVOKED">
                    <i class="mdi mdi-cash-refund" />
                </div>
                <div class="statusIcon" v-if="this.status === this.statusTypeEnum.DELETED">
                    <i class="mdi mdi-close-octagon-outline" />
                </div>
                <div class="statusIcon" v-if="this.status === this.statusTypeEnum.SCHEDULED">
                    <div class="mdi-icon-wrapper">
                        <i class="mdi mdi-alert-circle-outline"></i>
                    </div>
                </div>
            </div>
        </section>

        <modal
            :id="modalId"
            :show="modal.show"
            size="modal-lg"
            :title="this.originSystemName"
            :centered="true"
            :scrollable="true"
            :close="modal.hide"
            :closeable="true"
            :tighter-close-button="true"
            @modal-close="hideModal"
        >
            <div class="modal-body">
                <div class="text row">
                    <dl class="col-md-6 my-1">
                        <dt>{{ this.$t('shopEuropamaut.vignette') }}</dt>
                        <dd v-html="this.productName"></dd>
                    </dl>

                    <dl class="col-md-6 my-1">
                        <dt>{{ this.$t('shopEuropamaut.validTitle') }}</dt>
                        <dd>{{ this.validityStartDateTime }} - {{ this.validityEndDateTime }}</dd>
                    </dl>

                    <dl class="col-md-6 my-1">
                        <dt>{{ this.$t('orderCheckout.license') }}</dt>
                        <dd>{{ this.superOrder.country_code }} {{ this.superOrder.license }}</dd>
                    </dl>

                    <dl class="col-md-6 my-1">
                        <dt>{{ this.$t('order.registered-status') }}</dt>
                        <dd>
                            <span class="h6 mt-1 d-block text-success" v-if="this.status === (this.statusTypeEnum.FINISHED || this.statusTypeEnum.REVOKED)">
                                {{ this.$t('generic.yes') }}
                            </span>
                            <span class="h6 mt-1 d-block text-danger" v-if="this.status !== this.statusTypeEnum.FINISHED">{{ this.$t('generic.no') }}</span>
                        </dd>
                    </dl>

                    <div class="col-md-12 buttons" v-if="this.status === this.statusTypeEnum.FINISHED">
                        <a
                            @click.prevent="startFileDownload('confirmation')"
                            class="btn btn-sm btn-primary my-1"
                            style="font-size: 1rem"
                        >
                            <template v-if="downloadOngoing.confirmation">
                                <span class="spinner">
                                    <i class="mdi mdi-loading mdi-spin mr-1"></i>
                                </span>
                            </template>
                            <template v-else>
                                <i class="mdi mdi-download mr-1"></i>
                            </template>
                            {{ this.$t('order.download-confirmation') }}
                        </a>
                        <a
                            @click.prevent="startFileDownload('invoice')"
                            class="btn btn-sm btn-primary my-1"
                            style="font-size: 1rem"
                        >
                            <template v-if="downloadOngoing.invoice">
                                <span class="spinner">
                                    <i class="mdi mdi-loading mdi-spin mr-1"></i>
                                </span>
                            </template>
                            <template v-else>
                                <i class="mdi mdi-download mr-1"></i>
                            </template>
                            {{ this.$t('order.download-invoice') }}
                        </a>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { echo } from '../../echo.js';

export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
        superOrder: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            modal: {
                show: false,
                hide: true,
            },
            statusTypeEnum: Object.freeze({
                CREATED: 'created',
                STAGED: 'staged',
                FINISHED: 'finished',
                FAILED: 'failed',
                REVOKED: 'revoked',
                DELETED: 'deleted',
                INTERNAL_DUPLICATED: 'internal_duplicated',
                EXTERNAL_DUPLICATED: 'external_duplicated',
                SCHEDULED: 'scheduled',
            }),
            statusType: this.order.status,
            validityStart: this.order.validity_start,
            validityEnd: this.order.validity_end,
            dispatchAt: this.order.dispatch_at,
            confirmationUrl: this.order.additionalDetails.confirmationUrl,
            invoiceUrl: this.order.additionalDetails.invoiceUrl,
            downloadOngoing: {},
        };
    },

    computed: {
        validityStartDate() {
            return this.formatDate(new Date(this.validityStart));
        },

        validityEndDate() {
            return this.formatDate(new Date(this.validityEnd));
        },

        validityStartDateTime() {
            return this.formatDateTime(new Date(this.validityStart));
        },

        validityEndDateTime() {
            return this.formatDateTime(new Date(this.validityEnd));
        },

        dispatchAtDate() {
            return this.formatDate(new Date(this.dispatchAt));
        },

        durationLabel() {
            if (this.order.additionalDetails.product.duration.isMonth) {
                if (this.order.additionalDetails.product.duration.value > 1) {
                    return 'Monate';
                } else {
                    return 'Monat';
                }
            }

            if (this.order.additionalDetails.product.duration.value > 1) {
                return 'Tage';
            } else {
                return 'Tag';
            }
        },

        duration() {
            return this.order.additionalDetails.product.duration.value;
        },

        optionName() {
            const option = this.order.additionalDetails.product.options
                .find((e) => e.id === this.order.option_id);

            let label = '';
            if (
                option.vehicleNames === null ||
                !option.vehicleNames ||
                option.vehicleNames.length <= 0
            ) {
                label = option.labels[this.$language] ?? option.labels['en'];
            } else {
                label = option.vehicleNames[this.$language] ?? option.vehicleNames['en'];
            }

            return label.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, '');
        },

        modalId() {
            return `combinedOrderDetailInfoModal-${this.order.id}`;
        },

        productName() {
            return this.order.additionalDetails.product.names[this.$language] + ' - ' + this.optionName;
        },

        status() {
            switch (this.statusType) {
                case this.statusTypeEnum.FINISHED:
                    return this.statusTypeEnum.FINISHED;
                case this.statusTypeEnum.STAGED:
                    return this.statusTypeEnum.STAGED;
                case this.statusTypeEnum.REVOKED:
                    return this.statusTypeEnum.REVOKED;
                case this.statusTypeEnum.FAILED:
                case this.statusTypeEnum.INTERNAL_DUPLICATED:
                case this.statusTypeEnum.EXTERNAL_DUPLICATED:
                    return this.statusTypeEnum.FAILED;
                case this.statusTypeEnum.SCHEDULED:
                    return this.statusTypeEnum.SCHEDULED;
                case this.statusTypeEnum.CREATED: {
                    const now = new Date();
                    const createdAt = new Date(this.order.created_at);
                    const validityStart = new Date(this.validityStart);

                    if (Math.floor(now - validityStart / 1000) > 60 * 60 * 24 * 3) {
                        return this.statusTypeEnum.CREATED;
                    }

                    if (Math.floor(now - createdAt / 1000) < 60 * 3) {
                        return this.statusTypeEnum.STAGED;
                    }

                    return this.statusTypeEnum.CREATED;
                }
            }

            throw new Error('Unknown Status');
        },

        originSystemName() {
            return this.$t(`shop.${this.order.additionalDetails.product.system.key}`);
        },
    },

    methods: {
        formatDate(date) {
            const da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(date);
            const mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(date);
            const ye = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(date);
            return (da + '.' + mo + '.' + ye).toString();
        },

        formatDateTime(date) {
            const da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(date);
            const mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(date);
            const ye = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(date);
            const h = new Intl.DateTimeFormat('de', { hour: 'numeric', minute: 'numeric' }).format(date);
            return (da + '.' + mo + '.' + ye + ' ' + h).toString();
        },

        showModal() {
            if (this.status === this.statusTypeEnum.DELETED) {
                return this;
            }

            this.modal.show = true;
            this.modal.hide = false;

            return this;
        },

        hideModal() {
            this.modal.show = false;
            this.modal.hide = true;

            this.downloadOngoing = {};

            return this;
        },

        startFileDownload(type) {
            if (this.downloadOngoing[type]) {
                return;
            }

            this.downloadOngoing[type] = true;

            // Every 15s, max. 20 attempts => 5min timeout
            this.downloadFile(
                this[`${type}Url`],
                type,
                20,
                15000
            );
        },

        downloadFile(url, type, maxAttempts, delay) {
            let attempts = 0;

            const executeWithRetry = () => {
                attempts++;

                if (!this.downloadOngoing[type]) {
                    return;
                }

                return axios
                    .head(url)
                    .then((response) => {
                        if (response.status !== 200) {
                            throw new Error('File is not available!');
                        }

                        window.open(url, '_blank');
                        this.downloadOngoing[type] = false;
                    }).catch(() => {
                        if (attempts >= maxAttempts) {
                            this.downloadOngoing[type] = false;

                            throw new Error(`All ${maxAttempts} attempts failed`);
                        }

                        return setTimeout(() => executeWithRetry(), delay);
                    });
            };

            return executeWithRetry();
        },
    },

    mounted() {
        this.hideModal();

        if (!Object.values(this.statusTypeEnum).includes(this.order.status)) {
            throw new Error(`Unknown status "${this.order.status}" given.`);
        }

        const channelName = 'combinedOrder.' + this.superOrder.hash.replace(/-/g, '_') + '.' + this.order.id;
        echo.private(channelName)
            .listen('CombinedOrderUpdated', (event) => {
                if (event.orderChanges !== null) {
                    if (!Object.values(this.statusTypeEnum).includes(event.orderChanges.status)) {
                        throw new Error(`Unknown status "${event.orderChanges.status}" given.`);
                    }

                    this.statusType = event.orderChanges.status;
                    this.validityStart = event.orderChanges.validity_start;
                    this.validityEnd = event.orderChanges.validity_end;
                    this.invoiceUrl = event.orderChanges.invoiceUrl;
                    this.confirmationUrl = event.orderChanges.confirmationUrl;
                }
            });
    },
};
</script>
<style lang="scss" scoped>
.in-setup {
    color: #f59e0b;
}

.facts {
    display: flex;
    flex-wrap: wrap;
}

.container {
    border-radius: 10px;
    background: var(--main-background-light-light);
    min-height: 105px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    cursor: pointer;
}

.system-box {
    display: flex;
    align-items: center;
    padding: 1rem;
    text-align: center;
    width: 140px;
    margin: 0 0 0 .5rem;
}

.system-text {
    display: inline-block;
    max-width: min-content;
    font-size: 20px;
}

.icon {
    display: none;
}

.detail {
    border-radius: 5px;
    border: 1px solid var(--main-color-dark);
    background: var(--main-color);
    min-width: 130px;
    margin: 20px;
    color: #fff;
    text-align: center;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    padding: 5px;
}

.status {
    .text {
        width: 190px;
        margin-right: 20px;
    }

    display: flex;
    justify-content: center;
    align-items: center;
}

.info {
    display: flex;
    justify-content: center;
    flex: 1 100%;
}

.statusIcon {
    fill: var(--main-color);
    color: var(--main-color);

    i {
        font-size: 42px;
    }

    .expiredIcon {
        fill: var(--orange);
    }
}

dt::after {
    content: ': ';
}

.greyed {
    fill: grey;
    color: grey;
}

.modal-body .buttons {
    display: flex;
    justify-content: space-around;
}

.statusIconText {
    display: none;
}

@media (max-width: 767px) {
    .facts {
        justify-content: center;
    }

    .detail {
        width: 100%;
        margin: 0.3rem;
    }

    .detail:last-child {
        margin-bottom: 1rem;
    }

    .facts {
        width: 100%;
    }

    .status {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;
    }

    .status {
        width: 100%;
    }

    .type.detail.duration {
        display: block;
        flex: none;
        margin: 10px;
        max-width: -webkit-fill-available;
    }
}

@media (max-width: 991px) {
    .system-box {
        padding: 0;
        margin: .5rem 0 .75rem 0;
        width: 100%;
        text-align: center;
    }

    .system-text {
        display: flex;
        font-size: 22px;
        max-width: 100%;
        width: 100%;
        justify-content: center;
        align-items: center;
    }

    .detail {
        margin: 10px;
        display: flex;
        flex: 1;
    }

    .facts {
        width: 100%;
    }

    .status {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;
    }

    .icon {
        display: inline-block;
        font-size: 28px;
        margin-left: .5rem;
    }

    .statusIcon {
        display: none;
    }

    .statusIconText {
        display: block;
    }

    .modal-body .buttons {
        flex-wrap: wrap-reverse;

        a {
            width: 100%;
        }
    }
}
.mdi-icon-wrapper {
    width: 42px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<style lang="scss">
.statusIcon .spinner .mdi {
    font-size: 20px;
}

.statusIcon .spinner .spinner-text {
    font-size: 14px;
    padding-top: 0;
}

.statusIcon .preloader.p-4 {
    padding: 0.5rem !important;
}

.long-text {
    height: 105px;
}
</style>
